const expectedApplicationCode = 'platform_console' as const;
const configuredApplicationCode = import.meta.env.VITE_APPLICATION_CODE?.trim();
if (configuredApplicationCode && configuredApplicationCode !== expectedApplicationCode) {
  throw new Error('APPLICATION_CODE_MISMATCH');
}

export const application = {
  code: expectedApplicationCode,
  title: 'Platform Console',
  routes: [
    '/',
    '/login',
    '/signup',
    '/forgot-password',
    '/verify-email',
    '/auth/callback',
    '/invitation',
    '/suspended',
    '/privacy',
    '/terms',
    '/applications',
    '/applications/:id',
    '/users',
    '/users/:id',
    '/organizations',
    '/organizations/:id',
    '/app-accounts',
    '/app-accounts/:id',
    '/subscriptions',
    '/subscriptions/:id',
    '/checkout-orders',
    '/catalog',
    '/entitlements',
    '/credit-wallets',
    '/credit-ledger',
    '/webhooks',
    '/ai-jobs',
    '/ai-jobs/:id',
    '/providers',
    '/models',
    '/routes',
    '/prompts',
    '/prompts/:id',
    '/prompt-versions/:id',
    '/ai-usage',
    '/rag-monitor',
    '/analytics',
    '/audit',
    '/sensitive-access',
    '/system-health',
    '/observability',
    '/feature-flags',
    '/settings',
  ],
} as const;
